import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    RelationList,
    RelationTable,
    DataSelect,
    DatePicker,
} from '../../components/Form';


import {
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formCustomerMobile, setFormCustomerMobile] = useState(null);
    const [formCustomerName, setFormCustomerName] = useState(null);
    const [formAddress, setFormAddress] = useState(null);
    const [formPostCode, setFormPostCode] = useState(null);
    const [formPaymentMethodId, setFormPaymentMethodId] = useState(null);
    const [formPaymentMethodIdOptions, setFormPaymentMethodIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/payment-method-id').then(
            (response) => {
                setFormPaymentMethodIdOptions(response.data);
            }
        );
    }, []);
    const [formBoxSizeId, setFormBoxSizeId] = useState(null);
    const [formBoxSizeIdOptions, setFormBoxSizeIdOptions] = useState([]);
    const [formCityId, setFormCityId] = useState(null);
    const [formCityIdOptions, setFormCityIdOptions] = useState([]);
    const [formTotalWeight, setFormTotalWeight] = useState(null);
    const [formTotalListPrice, setFormTotalListPrice] = useState(null);
    const [formPayablePrice, setFormPayablePrice] = useState(null);
    const [formTitle, setFormTitle] = useState(null);
    const [formNote, setFormNote] = useState(null);
    const [formSendTime, setFormSendTime] = useState(null);
    const [formZoneId, setFormZoneId] = useState(null);
    const [formZoneIdOptions, setFormZoneIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/zone-id').then((response) => {
            setFormZoneIdOptions(response.data);
        });
    }, []);
    const [formPeikId, setFormPeikId] = useState(null);
    const [formPeikIdOptions, setFormPeikIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/peik-id').then((response) => {
            setFormPeikIdOptions(response.data);
        });
    }, []);
    const [formShiftId, setFormShiftId] = useState(null);
    const [formShiftIdOptions, setFormShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/shift-id').then((response) => {
            setFormShiftIdOptions(response.data);
        });
    }, []);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/city-id').then((response) => {
            setFormCityIdOptions(response.data);
        });
    }, []);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/select-data/box-size-id').then((response) => {
            setFormBoxSizeIdOptions(response.data);
        });
    }, []);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-orders-edit/save-data', {
            id: allProps['taroff-orders-id'],
            customer_mobile: formCustomerMobile,
            customer_name: formCustomerName,
            address: formAddress,
            post_code: formPostCode,
            city_id: formCityId,
            payment_method_id: formPaymentMethodId,
            box_size_id: formBoxSizeId,
            total_weight: formTotalWeight,
            total_list_price: formTotalListPrice,
            payable_price: formPayablePrice,
            title: formTitle,
            note: formNote,
            send_time: formSendTime,
            zone_id: formZoneId,
            peik_id: formPeikId,
            shift_id: formShiftId,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-edit/form-data', {
            id: allProps['taroff-orders-id'],
        }).then((response) => {
            setFormCustomerMobile(response.data.customer_mobile);
            setFormCustomerName(response.data.customer_name);
            setFormAddress(response.data.address);
            setFormPostCode(response.data.post_code);
            setFormCityId(response.data.city_id);
            setFormPaymentMethodId(response.data.payment_method_id);
            setFormBoxSizeId(response.data.box_size_id);
            setFormTotalWeight(response.data.total_weight);
            setFormTotalListPrice(response.data.total_list_price);
            setFormPayablePrice(response.data.payable_price);
            setFormTitle(response.data.title);
            setFormNote(response.data.note);
            setFormSendTime(response.data.send_time);
            setFormZoneId(response.data.zone_id);
            setFormPeikId(response.data.peik_id);
            setFormShiftId(response.data.shift_id);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Grid>
                    <GridColumn width={12}>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'همراه خریدار'}
                                    value={formCustomerMobile}
                                    onChange={setFormCustomerMobile}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'نام خریدار'}
                                    value={formCustomerName}
                                    onChange={setFormCustomerName}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <DataSelect
                                    label={'شهر مقصد'}
                                    options={formCityIdOptions}
                                    value={formCityId}
                                    onChange={setFormCityId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'آدرس'}
                                    value={formAddress}
                                    onChange={setFormAddress}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'کد پستی'}
                                    value={formPostCode}
                                    onChange={setFormPostCode}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <DataSelect
                                    label={'شیوه ی پرداخت'}
                                    options={formPaymentMethodIdOptions}
                                    value={formPaymentMethodId}
                                    onChange={setFormPaymentMethodId}
                                />
                            </GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <DataSelect
                                    label={'اندازه جعبه'}
                                    options={formBoxSizeIdOptions}
                                    value={formBoxSizeId}
                                    onChange={setFormBoxSizeId}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'وزن کل'}
                                    value={formTotalWeight}
                                    onChange={setFormTotalWeight}
                                />
                            </GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'مبلغ کل'}
                                    value={formTotalListPrice}
                                    onChange={setFormTotalListPrice}
                                />
                            </GridColumn>
                            <GridColumn width={4}>
                                <TextBox
                                    label={'مبلغ قابل پرداخت'}
                                    value={formPayablePrice}
                                    onChange={setFormPayablePrice}
                                />
                            </GridColumn>
                            <GridColumn width={4}></GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'عنوان'}
                                    value={formTitle}
                                    onChange={setFormTitle}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'یادداشت'}
                                    value={formNote}
                                    onChange={setFormNote}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DatePicker
                                    label={'زمان ارسال'}
                                    value={formSendTime}
                                    onChange={setFormSendTime}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <RelationList label={'پیوست ها‌ها'} />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <RelationTable label={'تراکنش ها'} />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'شناسه محدوده توزیع'}
                                    options={formZoneIdOptions}
                                    value={formZoneId}
                                    onChange={setFormZoneId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'شناسه پیک'}
                                    options={formPeikIdOptions}
                                    value={formPeikId}
                                    onChange={setFormPeikId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'شیفت های پیک تعارف'}
                                    options={formShiftIdOptions}
                                    value={formShiftId}
                                    onChange={setFormShiftId}
                                />
                            </GridColumn>
                        </Grid>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
